import { PageProps } from '@config/typing'
import { FC, ReactNode } from 'react'
import SplitScreen, { SplitVals } from '@common/SplitScreen'
import ScreenInfo from '@common/ScreenInfo'
import Center from '@common/Center'
import Illustration from '@brand/Illustration'
import { Breakpoint } from '@mui/material'

type Split = Record<Breakpoint, SplitVals>
const StaticPage: FC<PageProps & { action: ReactNode } & { split: Split }> = ({
  left,
  right,
  action,
  split,
}) => {
  return (
    <SplitScreen
      left={
        <ScreenInfo
          title={left.value.title}
          subText={left.value.subText}
          hideSubtext={left.value.hideSubtext}
          bodyText={left.value.bodyText}
          action={action}
          actionLabel={left.value.actionLabel}
        />
      }
      right={
        <Center
          contentOverrides={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            minHeight: { lg: '100vh', md: '50vh', xs: '30vh' },
          }}
          alignItems={'center'}
        >
          <Illustration
            name={right.value.name}
            height={{ xs: 200, sm: 200, md: 320, lg: 380 }}
          />
        </Center>
      }
      split={split}
    />
  )
}

export default StaticPage
